module.exports = {
  "version": "1.0.0-alpha.1"
};